import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OpfoelgningCountResponse } from 'src/app/api/models/OK/Egis/Service/Models/Response/opfoelgning-count-response';
import { OpfoelgningService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { AuthService } from 'src/app/services/auth.service';
import { OpfoelgningChanged, SignalrService } from 'src/app/services/signalr.service';

@Component({
    selector: 'app-opfoelgning-nav',
    templateUrl: './opfoelgning-nav.component.html',
    styleUrls: ['./opfoelgning-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpfoelgningNavComponent implements OnInit {
  antalOrdreOpfoelgninger: number = 0;
  antalAftaleOpfoelgninger: number = 0;
  showStatusMenuItem: boolean = false;

  unsubscribe$ = new Subject<void>();

  constructor(private opfoelgningService: OpfoelgningService, private signalR: SignalrService, private auth: AuthService) {
    this.showStatusMenuItem = auth.isAdministrator || auth.isSuperuser;
  }

  ngOnInit(): void {
    this.signalR.opfoelgningChanged$.pipe(takeUntil(this.unsubscribe$)).subscribe((response: OpfoelgningChanged) => {
      const username = this.auth.username;
      if (!response.opfoelgning || response.opfoelgning.modifiedBy.toLowerCase() == username?.toLowerCase()) {
        this.getData();
      }
    });

    this.getData();
  }

  getData() {
    this.opfoelgningService
      .getOpfoelgningCountsForCurrentUser({ caller: EGIS_SERVICE_CALLER })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response: OpfoelgningCountResponse) => {
        this.antalAftaleOpfoelgninger = response.serviceaftaleOpfoelgningerCount;
        this.antalOrdreOpfoelgninger = response.servicordreOpfoelgningerCount;
      });
  }
}
